"use client";

import Image from "next/image";
import { motion } from "framer-motion";

export default function AboutHero({
  eyebrow,
  titleLine1,
  titleLine2,
  paragraph,
  imageSrc,
  imageAlt,
  titleItalic = false,
}: {
  eyebrow: string;
  titleLine1: string;
  titleLine2: string;
  paragraph: string;
  imageSrc: string;
  imageAlt: string;
  /** Met tout le titre en italique (sinon : ligne 1 romaine, ligne 2 italique). */
  titleItalic?: boolean;
}) {
  return (
    <section className="relative overflow-hidden">
      <div className="relative h-[78vh] min-h-[560px] w-full">
        <Image
          src={imageSrc}
          alt={imageAlt}
          fill
          priority
          className="object-cover"
          sizes="100vw"
        />

        <div className="absolute inset-0 bg-black/30" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/25 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/10 to-transparent" />

        <div className="relative z-10 mx-auto flex h-full max-w-6xl items-center px-4 pt-28 pb-16 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="max-w-2xl"
          >
            <p className="font-body font-light uppercase tracking-[0.35em] text-white/60 text-xs md:text-sm">
              {eyebrow}
            </p>

            <h1
              className={`mt-6 font-heading text-5xl md:text-7xl leading-[1.05] font-light tracking-tight text-white${
                titleItalic ? " italic" : ""
              }`}
            >
              {titleLine1} <br />
              <span className="italic">{titleLine2}</span>
            </h1>

            <p className="mt-8 font-body font-light text-lg md:text-xl text-white/75 leading-relaxed">
              {paragraph}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
